import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../../../generic/FieldProps';
import { DivorceDateInput } from './DivorceDateInput';

export function DivorceDateField<TValues extends FieldValues>({
  name,
  required = false,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <DivorceDateInput
      value={value as string}
      onChange={onChange}
      required={required}
      label='Scheidungsdatum'
    />
  );
}
